import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Drawer, Button, MenuItem, Select } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useHistory } from 'react-router';
import {
  IN_ROOM_DINING_ADDONS,
  IN_ROOM_DINING_ALLERGENS,
  IN_ROOM_DINING_COMBO,
  IN_ROOM_DINING_CATEGORY,
  IN_ROOM_DINING_CATEGORY_CREATE,
  IN_ROOM_DINING_CATEGORY_EDIT,
  IN_ROOM_DINING_CATEGORY_VIEW,
  IN_ROOM_DINING_CUSTOMISATIONS,
  IN_ROOM_DINING_CUSTOMISATIONS_CREATE,
  IN_ROOM_DINING_CUSTOMISATIONS_EDIT,
  IN_ROOM_DINING_CUSTOMISATIONS_VIEW,
  IN_ROOM_DINING_DISCOUNT,
  IN_ROOM_DINING_ITEMS,
  IN_ROOM_DINING_ITEMS_VIEW,
  IN_ROOM_DINING_MENU,
  IN_ROOM_DINING_MENU_CREATE,
  IN_ROOM_DINING_MENU_VIEW,
  IN_ROOM_DINING_TAGS,
  IN_ROOM_DINING_TAGS_CREATE,
  IN_ROOM_DINING_TAGS_EDIT,
  IN_ROOM_DINING_TAGS_VIEW,
  IN_ROOM_DINING_ALLERGENS_CREATE,
  IN_ROOM_DINING_ALLERGENS_EDIT,
  IN_ROOM_DINING_ADDONS_CREATE,
  IN_ROOM_DINING_ADDONS_EDIT,
  IN_ROOM_DINING_DISCOUNTS_EDIT,
  IN_ROOM_DINING_DISCOUNTS_CREATE,
  IN_ROOM_DINING_DISCOUNTS_VIEW,
  IN_ROOM_DINING_MENU_CREATE_TYPE,
  IN_ROOM_DINING_COMBO_CREATE,
  IN_ROOM_DINING_COMBO_EDIT,
  IN_ROOM_DINING_ITEMS_CREATE,
  IN_ROOM_DINING_ITEMS_EDIT,
  IN_ROOM_DINING_COMBO_VIEW,
  IN_ROOM_DINING_MENU_CREATE_DRAWER,
  IN_ROOM_DINING_ADDONS_VIEW,
  IN_ROOM_DINING_ALLERGENS_VIEW,
  IN_ROOM_DINING_MENU_INFO_VIEW,
  IN_ROOM_DINING_MENU_EDIT_DRAWER,
  MENU_CONFIGURATION,
} from '../../../constants/InRoomDiningConst';
import InRoomDiningCategoryList from './category/category-list/Category-List';
import {
  allRestaurantSelector,
  selectedHotelSelector,
  allPropertyConfigsSelector,
} from '../../property/propertySlice';
import {
  fetchAllInRoomDining,
  fetchAllInRoomDiningMenu,
  inRoomDiningLoaderSelector,
  setIRDMenu,
  setInRoomDining,
} from '../servicesSlice';
import InRoomDiningCategoryCreate from './category/category-create/Category-Create';
import InRoomDiningCategoryView from './category/category-view/Category-View';
import ItemsListView from './items/items-list/Items-List';
import ItemsView from './items/items-view/Items-View';
import InRoomDiningCustomisationList from './customisation/customisation-list/Customisation-List';
import InRoomDiningCustomisationCreate from './customisation/customisation-create/Customisation-Create';
import TagsListView from './tags/tags-list/Tags-List';
import TagsCreate from './tags/tags-create/Tags-Create';
import AllergensListView from './allergens/allergens-list/Allergens-List';
import AllergensCreate from './allergens/allergens-create/Allergens-Create';
import AddonsListView from './addons/addons-list/Addons-List';
import AddonsCreate from './addons/addons-create/Addons-Create';
import DiscountsListView from './discount/discount-list/Discount-List';
import DiscountView from './discount/discount-view/Discounts-View';
import InRoomDiningComboList from './combo/combo-list/Combo-List';
import InRoomDiningComboCreate from './combo/combo-create/Combo-Create';
import DiscountCreate from './discount/discount-create/Discounts-Create';
import InRoomDiningMenuList from './menu/menu-list/Menu-List';
import InRoomDiningMenuCreateType from './menu/menu-create/Menu-Create-Type';
import InRoomDiningMenuCreate from './menu/menu-create/Menu-Create';
import ItemsCreate from './items/items-create/Items-Create';
import InRoomDiningComboView from './combo/combo-view/Combo-View';
import MenuCreateDrawer from './menu/menu-create/Menu-Create-Drawer';
import MenuView from './menu/menu-view/Menu-View';
import InRoomDiningCustomisationView from './customisation/customisation-view/Customisation-View';
import InRoomDiningAddonView from './addons/addons-view/Addon-View';
import InRoomDiningTagView from './tags/tags-view/Tag-View';
import InRoomDiningAllergenView from './allergens/allergens-view/Allergen-View';
import { validateUserSession, decryptLocalStorage } from '../../../utils/authUtils';
import MenuViewTabs from './menu/menu-view/MenuViewTabs';
import MenuEditDrawer from './menu/menu-create/MenuEditDrawer';
import {
  setDashboardSelectedRestaurant,
  setMenuConfigSelectedRestaurant,
} from '../../property/propertySlice';
import { FormControl } from '@mui/material';
import { checkAuthState } from '../../../utils/APIUtils';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../constants/RoleConsts';
import { generatedElapsedTime } from '../../../utils/dashboardUtils';
import SyncButton from '../../../shared/sync-button/Sync-Button';
import { syncPos } from '../../../utils/PropertyAPIUtils';
import { notificationManager } from '../../../utils/NotificationUtils';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const InRoomDining = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const selectedHotel = useSelector(selectedHotelSelector);
  const inRoomDiningLoader = useSelector(inRoomDiningLoaderSelector);
  const originalRestList = useSelector(allRestaurantSelector);
  const propertyConfigs = useSelector(allPropertyConfigsSelector);
  const [selectedRestaurant, setRestaurant] = useState(null);
  const history = useHistory();
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(IN_ROOM_DINING_MENU);
  const [menuViewObject, setMenuViewObject] = useState(null);
  const [lastSync, setLastSync] = useState(0);
  const [state, setState] = useState({
    type: IN_ROOM_DINING_MENU_CREATE,
    status: false,
  });
  const [viewState, setViewState] = useState({
    type: IN_ROOM_DINING_MENU_VIEW,
    status: false,
    obj: null,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isCulinaryOperationManager, setIsCulinaryOperationManager] = useState(false);
  const [irdMode, setIrdMode] = useState(
    selectedRestaurant || isCulinaryOperationManager ? false : true,
  );
  const [language, setLanguage] = useState(() => decryptLocalStorage('lang') ?? 'en');
  const dispatch = useDispatch();
  useEffect(() => {
    if (
      activeTab === IN_ROOM_DINING_CATEGORY ||
      activeTab === IN_ROOM_DINING_ITEMS ||
      activeTab === IN_ROOM_DINING_CUSTOMISATIONS ||
      activeTab === IN_ROOM_DINING_ADDONS ||
      activeTab === IN_ROOM_DINING_TAGS ||
      activeTab === IN_ROOM_DINING_ALLERGENS ||
      activeTab === IN_ROOM_DINING_DISCOUNT ||
      activeTab === IN_ROOM_DINING_COMBO ||
      activeTab === IN_ROOM_DINING_MENU
    ) {
      setPage(0);
      setRowsPerPage(5);
    }
  }, [activeTab]);

  useEffect(() => {
    setRestaurant(null);
    setIrdMode(true);
    dispatch(setDashboardSelectedRestaurant());
    dispatch(setMenuConfigSelectedRestaurant());
  }, [selectedHotel]);

  useEffect(() => {
    (async () => {
      const currUser = await checkAuthState();
      if (
        currUser &&
        currUser?.attributes &&
        currUser?.attributes['custom:role'] === 'CULINARY_OPERATIONS_MANAGER'
      ) {
        setIrdMode(false);
        setIsCulinaryOperationManager(true);
      }
    })();
  }, [originalRestList, selectedRestaurant]);

  useEffect(() => {
    validateUserSession(history);
  }, [activeTab, history]);

  useEffect(() => {
    if (selectedHotel && viewState.status) {
      setActiveTab(IN_ROOM_DINING_MENU);
      setViewState({
        type: '',
        status: false,
        obj: null,
      });
    }
  }, [selectedHotel]);
  useEffect(() => {
    if (isCulinaryOperationManager && !selectedRestaurant) {
      setTimeout(() => {
        setRestaurant(originalRestList[0]);
      }, 500);
    }
  }, [isCulinaryOperationManager, selectedRestaurant, originalRestList]);

  useEffect(() => {
    const handleStorageChange = () => {
      const currentLang = decryptLocalStorage('lang') ?? 'en';
      if (currentLang !== language) {
        setLanguage(currentLang);
      }
    };
    
    const checkInterval = setInterval(handleStorageChange, 10);
    
    return () => {
      clearInterval(checkInterval);
    };
  }, [language]);

  useEffect(() => {
    let selectedRestaurantId = selectedRestaurant ? selectedRestaurant?.id : '';
    dispatch(setInRoomDining());
    dispatch(setIRDMenu());
    dispatch(fetchAllInRoomDining(selectedHotel, selectedRestaurantId));
    dispatch(fetchAllInRoomDiningMenu(selectedHotel, selectedRestaurantId));
  }, [selectedRestaurant, selectedHotel, language]);

  useEffect(() => {
    if (propertyConfigs?.ird) {
      let timeDifference = generatedElapsedTime(
        moment(),
        moment.unix(propertyConfigs?.ird?.lastSyncedAt),
        true,
      );
      setLastSync(timeDifference);
    }
  }, [propertyConfigs]);

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const onViewToggle = (type, status, obj) => {
    setViewState({ type: type, status: status, obj: obj });
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const handleResChange = (e) => {
    if (e.target.value && e.target.value !== 'ird' && originalRestList.length > 0) {
      const newSelected = originalRestList.find((restaurant) => restaurant.id === e.target.value);
      setRestaurant(newSelected);
      dispatch(setDashboardSelectedRestaurant(newSelected));
      dispatch(setMenuConfigSelectedRestaurant(newSelected));
      setIrdMode(false);
    } else {
      setIrdMode(true);
      setRestaurant(null);
      dispatch(setDashboardSelectedRestaurant());
      dispatch(setMenuConfigSelectedRestaurant());
    }
    dispatch(fetchAllInRoomDining(selectedHotel, e.target.value != 'ird' ? e.target.value : ''));
    dispatch(
      fetchAllInRoomDiningMenu(selectedHotel, e.target.value != 'ird' ? e.target.value : ''),
    );
  };

  const onClickSync = async (e) => {
    e.preventDefault();

    try {
      const res = await syncPos(selectedHotel);
      if (res?.data?.syncPOS?.status) {
        setTimeout(() => {
          let selectedRestaurantId = selectedRestaurant ? selectedRestaurant?.id : '';
          dispatch(fetchAllInRoomDining(selectedHotel, selectedRestaurantId));
          dispatch(fetchAllInRoomDiningMenu(selectedHotel, selectedRestaurantId));
        }, 2000);
      }
      notificationManager(
        res?.data?.syncPOS?.status ? 'success' : 'danger',
        res?.data?.syncPOS?.message,
      );
    } catch (err) {
      console.error(err);
    }
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case IN_ROOM_DINING_CATEGORY_CREATE:
        return (
          <InRoomDiningCategoryCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            showLoader={showLoader}
          />
        );
      case IN_ROOM_DINING_CATEGORY_EDIT:
        return (
          <InRoomDiningCategoryCreate
            toggleDrawer={onDrawerToggle}
            category={state.obj}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            showLoader={showLoader}
          />
        );
      case IN_ROOM_DINING_TAGS_CREATE:
        return (
          <TagsCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            showLoader={showLoader}
          />
        );
      case IN_ROOM_DINING_TAGS_EDIT:
        return (
          <TagsCreate
            toggleDrawer={onDrawerToggle}
            tagItem={state.obj}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            showLoader={showLoader}
          />
        );
      case IN_ROOM_DINING_ALLERGENS_CREATE:
        return (
          <AllergensCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            showLoader={showLoader}
          />
        );
      case IN_ROOM_DINING_ALLERGENS_EDIT:
        return (
          <AllergensCreate
            toggleDrawer={onDrawerToggle}
            allergen={state.obj}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            showLoader={showLoader}
          />
        );
      case IN_ROOM_DINING_ADDONS_CREATE:
        return (
          <AddonsCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            showLoader={showLoader}
          />
        );
      case IN_ROOM_DINING_ADDONS_EDIT:
        return (
          <AddonsCreate
            toggleDrawer={onDrawerToggle}
            addon={state.obj}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            showLoader={showLoader}
          />
        );
      case IN_ROOM_DINING_CUSTOMISATIONS_CREATE:
        return (
          <InRoomDiningCustomisationCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            showLoader={showLoader}
          />
        );
      case IN_ROOM_DINING_CUSTOMISATIONS_EDIT:
        return (
          <InRoomDiningCustomisationCreate
            toggleDrawer={onDrawerToggle}
            customisation={state.obj}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            showLoader={showLoader}
          />
        );
      case IN_ROOM_DINING_COMBO_CREATE:
        return (
          <InRoomDiningComboCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            showLoader={showLoader}
          />
        );
      case IN_ROOM_DINING_COMBO_EDIT:
        return (
          <InRoomDiningComboCreate
            toggleDrawer={onDrawerToggle}
            combo={state.obj}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            showLoader={showLoader}
          />
        );
      case IN_ROOM_DINING_DISCOUNTS_CREATE:
        return (
          <DiscountCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            showLoader={showLoader}
          />
        );
      case IN_ROOM_DINING_DISCOUNTS_EDIT:
        return (
          <DiscountCreate
            toggleDrawer={onDrawerToggle}
            discount={state.obj}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            showLoader={showLoader}
          />
        );
      case IN_ROOM_DINING_ITEMS_CREATE:
        return (
          <ItemsCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            showLoader={showLoader}
          />
        );
      case IN_ROOM_DINING_ITEMS_EDIT:
        return (
          <ItemsCreate
            toggleDrawer={onDrawerToggle}
            selectedItem={state.obj}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            showLoader={showLoader}
          />
        );
      case IN_ROOM_DINING_MENU_CREATE_DRAWER:
        return (
          <MenuCreateDrawer
            toggleDrawer={onDrawerToggle}
            menu={state.obj}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
          />
        );
      case IN_ROOM_DINING_MENU_EDIT_DRAWER:
        return (
          <MenuEditDrawer
            toggleDrawer={onDrawerToggle}
            menu={state.obj}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
          />
        );
      default:
        break;
    }
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case IN_ROOM_DINING_MENU_VIEW:
        return (
          <MenuView
            permissions={permissions}
            selectedMenuForId={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
            menuViewObject={menuViewObject}
            setMenuViewObject={setMenuViewObject}
          />
        );
      case IN_ROOM_DINING_CATEGORY_VIEW:
        return (
          <InRoomDiningCategoryView
            permissions={permissions}
            category={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
          />
        );
      case IN_ROOM_DINING_CUSTOMISATIONS_VIEW:
        return (
          <InRoomDiningCustomisationView
            permissions={permissions}
            customisation={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
          />
        );
      case IN_ROOM_DINING_ADDONS_VIEW:
        return (
          <InRoomDiningAddonView
            permissions={permissions}
            addon={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
          />
        );
      case IN_ROOM_DINING_TAGS_VIEW:
        return (
          <InRoomDiningTagView
            permissions={permissions}
            tag={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
          />
        );
      case IN_ROOM_DINING_ALLERGENS_VIEW:
        return (
          <InRoomDiningAllergenView
            permissions={permissions}
            allergen={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
          />
        );
      case IN_ROOM_DINING_ITEMS_VIEW:
        return (
          <ItemsView
            permissions={permissions}
            item={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            menuViewObject={menuViewObject}
            setMenuViewObject={setMenuViewObject}
          />
        );
      case IN_ROOM_DINING_DISCOUNTS_VIEW:
        return (
          <DiscountView
            permissions={permissions}
            discount={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
          />
        );
      case IN_ROOM_DINING_MENU_CREATE_TYPE:
        return (
          <InRoomDiningMenuCreateType
            permissions={permissions}
            onViewToggle={onViewToggle}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
          />
        );
      case IN_ROOM_DINING_MENU_CREATE:
        return (
          <InRoomDiningMenuCreate
            permissions={permissions}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            menu={inpState.obj}
            hotelId={selectedHotel}
            restaurantId={selectedRestaurant?.id ?? ''}
          />
        );
      case IN_ROOM_DINING_COMBO_VIEW:
        return (
          <InRoomDiningComboView
            permissions={permissions}
            combo={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            menuViewObject={menuViewObject}
            setMenuViewObject={setMenuViewObject}
          />
        );
      case IN_ROOM_DINING_MENU_INFO_VIEW:
        return (
          <MenuViewTabs
            permissions={permissions}
            combo={inpState.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            menuViewObject={menuViewObject}
            setMenuViewObject={setMenuViewObject}
          />
        );
      default:
        break;
    }
  };

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {viewState.status ? (
        <>{switchViewContent(viewState)}</>
      ) : (
        <div className='container mt-4'>
          <div className='row d-flex'>
            <div className='col-md-6'>
              <span className='page-title'>{MENU_CONFIGURATION}</span>
            </div>
            <div className='col-md-6 d-flex justify-content-end pe-5'>
              {propertyConfigs?.ird?.isEnabled &&
                permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] ===
                  RBAC_PERMISSION_LEVEL_FULL_ACCESS &&
                activeTab === IN_ROOM_DINING_MENU && (
                  <div className='pe-4'>
                    <SyncButton lastSync={lastSync} onClickSync={onClickSync} />
                  </div>
                )}
              <Button
                className='me-4 py-2 dropdown-button'
                variant='outlined'
                color='secondary'
                size='medium'
              >
                <FormControl variant='standard' sx={{ mx: 1, minWidth: 240 }}>
                  <Select
                    labelId='restlist-label'
                    id='rest-select-standard'
                    value={!irdMode ? selectedRestaurant?.id : 'ird'}
                    onChange={(e) => handleResChange(e)}
                    label='Select Restaurant'
                    className='dashboard-restaurant-list-dropdown'
                  >
                    {!isCulinaryOperationManager && (
                      <MenuItem value={'ird'}>{'In-Room Dining'}</MenuItem>
                    )}
                    {originalRestList?.map((rest) => (
                      <MenuItem key={rest.id} value={rest.id}>
                        {rest.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Button>
            </div>
          </div>
          <div className='row d-flex mt-4'>
            <div className='d-flex gap-3 flex-wrap'>
              <Button
                size='large'
                variant={activeTab === IN_ROOM_DINING_MENU ? 'outlined' : 'text'}
                className={
                  activeTab === IN_ROOM_DINING_MENU
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(IN_ROOM_DINING_MENU)}
              >
                {IN_ROOM_DINING_MENU}
              </Button>
              <Button
                size='large'
                variant={activeTab === IN_ROOM_DINING_CATEGORY ? 'outlined' : 'text'}
                className={
                  activeTab === IN_ROOM_DINING_CATEGORY
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(IN_ROOM_DINING_CATEGORY)}
              >
                {IN_ROOM_DINING_CATEGORY}
              </Button>
              <Button
                size='large'
                variant={activeTab === IN_ROOM_DINING_COMBO ? 'outlined' : 'text'}
                className={
                  activeTab === IN_ROOM_DINING_COMBO
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(IN_ROOM_DINING_COMBO)}
              >
                {IN_ROOM_DINING_COMBO}
              </Button>
              <Button
                size='large'
                variant={activeTab === IN_ROOM_DINING_ITEMS ? 'outlined' : 'text'}
                className={
                  activeTab === IN_ROOM_DINING_ITEMS
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(IN_ROOM_DINING_ITEMS)}
              >
                {IN_ROOM_DINING_ITEMS}
              </Button>
              <Button
                size='large'
                variant={activeTab === IN_ROOM_DINING_CUSTOMISATIONS ? 'outlined' : 'text'}
                className={
                  activeTab === IN_ROOM_DINING_CUSTOMISATIONS
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(IN_ROOM_DINING_CUSTOMISATIONS)}
              >
                {IN_ROOM_DINING_CUSTOMISATIONS}
              </Button>
              <Button
                size='large'
                variant={activeTab === IN_ROOM_DINING_ADDONS ? 'outlined' : 'text'}
                className={
                  activeTab === IN_ROOM_DINING_ADDONS
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(IN_ROOM_DINING_ADDONS)}
              >
                {IN_ROOM_DINING_ADDONS}
              </Button>
              <Button
                size='large'
                variant={activeTab === IN_ROOM_DINING_TAGS ? 'outlined' : 'text'}
                className={
                  activeTab === IN_ROOM_DINING_TAGS
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(IN_ROOM_DINING_TAGS)}
              >
                {IN_ROOM_DINING_TAGS}
              </Button>
              <Button
                size='large'
                variant={activeTab === IN_ROOM_DINING_ALLERGENS ? 'outlined' : 'text'}
                className={
                  activeTab === IN_ROOM_DINING_ALLERGENS
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(IN_ROOM_DINING_ALLERGENS)}
              >
                {IN_ROOM_DINING_ALLERGENS}
              </Button>
              <Button
                size='large'
                variant={activeTab === IN_ROOM_DINING_DISCOUNT ? 'outlined' : 'text'}
                className={
                  activeTab === IN_ROOM_DINING_DISCOUNT
                    ? classes.activeButton
                    : classes.button + 'showpopup'
                }
                onClick={() => setActiveTab(IN_ROOM_DINING_DISCOUNT)}
              >
                {IN_ROOM_DINING_DISCOUNT}
              </Button>
            </div>
          </div>
          <div className='row mx-2 d-flex mt-4'>
            <div className='card shadow'>
              {activeTab === IN_ROOM_DINING_CATEGORY && (
                <InRoomDiningCategoryList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  state={state}
                  hotelId={selectedHotel}
                  restaurantId={selectedRestaurant?.id ?? ''}
                  permissions={permissions}
                  inRoomDiningLoader={inRoomDiningLoader}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                  isHideAddButton={isCulinaryOperationManager && originalRestList.length === 0}
                />
              )}
              {activeTab === IN_ROOM_DINING_ITEMS && (
                <ItemsListView
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  state={state}
                  hotelId={selectedHotel}
                  restaurantId={selectedRestaurant?.id ?? ''}
                  permissions={permissions}
                  inRoomDiningLoader={inRoomDiningLoader}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                  isHideAddButton={isCulinaryOperationManager && originalRestList.length === 0}
                />
              )}
              {activeTab === IN_ROOM_DINING_CUSTOMISATIONS && (
                <InRoomDiningCustomisationList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  state={state}
                  hotelId={selectedHotel}
                  restaurantId={selectedRestaurant?.id ?? ''}
                  permissions={permissions}
                  inRoomDiningLoader={inRoomDiningLoader}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                  isHideAddButton={isCulinaryOperationManager && originalRestList.length === 0}
                />
              )}
              {activeTab === IN_ROOM_DINING_ADDONS && (
                <AddonsListView
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  state={state}
                  hotelId={selectedHotel}
                  restaurantId={selectedRestaurant?.id ?? ''}
                  permissions={permissions}
                  inRoomDiningLoader={inRoomDiningLoader}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                  isHideAddButton={isCulinaryOperationManager && originalRestList.length === 0}
                />
              )}
              {activeTab === IN_ROOM_DINING_TAGS && (
                <TagsListView
                  onDrawerToggle={onDrawerToggle}
                  state={state}
                  onViewToggle={onViewToggle}
                  hotelId={selectedHotel}
                  restaurantId={selectedRestaurant?.id ?? ''}
                  permissions={permissions}
                  inRoomDiningLoader={inRoomDiningLoader}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                  isHideAddButton={isCulinaryOperationManager && originalRestList.length === 0}
                />
              )}
              {activeTab === IN_ROOM_DINING_ALLERGENS && (
                <AllergensListView
                  onDrawerToggle={onDrawerToggle}
                  state={state}
                  onViewToggle={onViewToggle}
                  hotelId={selectedHotel}
                  restaurantId={selectedRestaurant?.id ?? ''}
                  permissions={permissions}
                  inRoomDiningLoader={inRoomDiningLoader}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                  isHideAddButton={isCulinaryOperationManager && originalRestList.length === 0}
                />
              )}
              {activeTab === IN_ROOM_DINING_DISCOUNT && (
                <DiscountsListView
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  state={state}
                  hotelId={selectedHotel}
                  restaurantId={selectedRestaurant?.id ?? ''}
                  permissions={permissions}
                  inRoomDiningLoader={inRoomDiningLoader}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                  isHideAddButton={isCulinaryOperationManager && originalRestList.length === 0}
                />
              )}
              {activeTab === IN_ROOM_DINING_COMBO && (
                <InRoomDiningComboList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  state={state}
                  hotelId={selectedHotel}
                  restaurantId={selectedRestaurant?.id ?? ''}
                  permissions={permissions}
                  inRoomDiningLoader={inRoomDiningLoader}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                  isHideAddButton={isCulinaryOperationManager && originalRestList.length === 0}
                />
              )}
              {activeTab === IN_ROOM_DINING_MENU && (
                <InRoomDiningMenuList
                  onDrawerToggle={onDrawerToggle}
                  onViewToggle={onViewToggle}
                  state={state}
                  hotelId={selectedHotel}
                  restaurantId={selectedRestaurant?.id ?? ''}
                  permissions={permissions}
                  inRoomDiningLoader={inRoomDiningLoader}
                  onsetPage={(e) => setPage(e)}
                  page={page}
                  onsetRowsPerPage={(e) => setRowsPerPage(e)}
                  rowsPerPage={rowsPerPage}
                  isHideAddButton={isCulinaryOperationManager && originalRestList.length === 0}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InRoomDining;
